import { baseAPI } from "../../baseApi";

export const selectOptionsSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getCities: builder.query({
      query: () => ({
        url: "cities",
        method: "GET",
      }),
    }),
    getCountries: builder.query({
      query: () => ({
        url: "countries",
        method: "GET",
      }),
    }),
    getSupplierCategories: builder.query({
      query: () => ({
        url: "supplier-categories",
        method: "GET",
      }),
    }),
    getSupplierDestination: builder.query({
      query: () => ({
        url: "supplier-designation",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetCitiesQuery,
  useGetCountriesQuery,
  useGetSupplierCategoriesQuery,
  useGetSupplierDestinationQuery,
} = selectOptionsSlice;
